import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { ApiConstant } from "const";
import { ApiUtils, HumpUtils, SystemUtils } from "utils";
import useInvalidateQueries from "hooks/common/useInvalidateQueries";
import qs from "qs";

export default function useCreateBotMessage() {
  const { t: getLabel } = useTranslation();

  const createBotMessageMutation = useMutation({
    mutationFn: async data => {
      const payload = data;
      const response = await ApiUtils.createApiWithToken(false).post(
        ApiConstant.CREATE_BOT_MESSAGE,
        qs.stringify(HumpUtils.decamelizeKeys(payload)),
      );
      return HumpUtils.camelizeKeys(response.data);
    },
    onMutate: () => {
      SystemUtils.openCircleLoading();
    },
    onSettled: () => {
      SystemUtils.openCircleLoading(false);
    },
    onSuccess: async (response, { onClose }) => {
      if (response.status === ApiConstant.STT_OK) {
        onClose();
      } else {
        SystemUtils.appendNotification("Cài đặt tin nhắn thất bại", "error");
      }
    },
    onError: error => {
      console.error(error);
      SystemUtils.appendNotification("Cài đặt tin nhắn thất bại", "error");
    },
  });

  const createBotMessage = payload => {
    createBotMessageMutation.mutate(payload);
  };

  return { createBotMessage };
}
